/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBarUp = createReactComponent("arrow-bar-up", "IconArrowBarUp", [
  ["path", { d: "M12 4l0 10", key: "svg-0" }],
  ["path", { d: "M12 4l4 4", key: "svg-1" }],
  ["path", { d: "M12 4l-4 4", key: "svg-2" }],
  ["path", { d: "M4 20l16 0", key: "svg-3" }]
]);

export { IconArrowBarUp as default };
//# sourceMappingURL=IconArrowBarUp.js.map
